/*

	aspectheight

	usage:

	the height is calculated to preserve the aspect ratio from a provided image or given value

	return:
	height
*/

const refSize = {
          w: 160,
          h: 90
      };

const MATHROUND = Math.round;

const heightFromAspectRatio = function (w, refW, refH) {
    const rw = (refW || refSize.w);
    const rh = (refH || refSize.h);
    return MATHROUND((rh / rw) * w);
};

export default {
	refSize() {
		return refSize;
	},
	scaledHeight(w, refH, refW) {
		/*optional refH, refW - If not provided the preset format is used*/
		refSize.w = (refW || refSize.w);
		refSize.h = (refH || refSize.h);
		return heightFromAspectRatio(w, refW, refH);
	}

};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/common/lib/utils/aspectheight.js